// extracted by mini-css-extract-plugin
module.exports = {"sok":"dhsgNahNe-sok"};